const translations = {
  title: 'Segmentations',
  'menu.import': 'Import',
  'menu.importHistory': 'Import History',
  'menu.export': 'Export',
  'menu.exportHistory': 'Export History',
  'table.name': 'Name',
  'table.createdAt': 'Created at',
  'table.updatedAt': 'Updated at'
}

export default translations
